// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3C1fn","upload":"Small_upload__3K44G","imageWrap":"Small_imageWrap__27zpr","removeBtn":"Small_removeBtn__3fTt_"};